<template>
  <div v-if="item !== undefined" class="src-view p-2">
    <cover v-if="item.type.split('/')[0] === 'image'" :item="item"  />
    <pdf v-else-if="item.type.split('/')[0] === 'application'" :item="item" />
    <player v-else-if="item.type.split('/')[0] === 'video'" :item="item" />
    <span v-else>Visualização não disponível</span>
  </div>
</template>

<script>
import Image from "./../viewer/Image"
import Pdf from "./../viewer/Pdf"
import Video from "./../viewer/Video"

export default {
  props: {
    item: {
      type: Object,
    }
  },
  components: {
    "cover": Image,
    "pdf": Pdf,
    "player": Video
  },
  data () {
    return {
      type: ""
    }
  },
}
// <style lang="sass" scoped>
//    @import url("https://cdn.plyr.io/3.5.6/plyr.css")
// </style>
</script>

